<template>
  <div class="sidebar-title text_size_16" :class="{'cursor-pointer': isPointer}" @click="callback">
    <div class="title-box">
      <p class="text_color_primary">
        <slot></slot>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isPointer: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    callback () {
      this.$emit('callback')
    }
  },
  computed: {
    type () {
      return this.$route.query.type
    }
  }
}
</script>
<style lang="scss" scoped>
  .sidebar-title {
    width: 100%;
    height: 50px;
    padding: 0 10px 0 10px;
    background-color: $bg-color-sidebar;
    .title-box {
      display: flex;
      align-items: center;
      text-align: left;
      width: 100%;
      height: 100%;
      padding-left: 10px;
      // border-bottom: 1px solid $border-color-base;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout-container/sidebar/sidebar-title.vue